// This is a very important piece of Javascript
//
// This runs on every single "page", blocking document "ready" (and so, pretty much all JS) until it's completed.

// It's job is to contact the session_ping#index controller action, and then decorate the page
// with any user-specific / session-specific content, like member names, flash messages, and authneticity tokens.
//
// The response it uses looks like this:
//
// {
//   "name":"Consumer staff",
//   "authenticity_token":"6Cbd5KmKASCfY3vTlegbIb1gsoX/J330lq12xjZTSQh4jHd4nsckle/H2LYQV3UV5dJPPCxswA5BzieUXcIXdw==",
//   "flash":"",
//   "id":10015002,
//   "google_analytics_events":""
// }
//
// The purpose of this is to allow user-specific features to work on pages that are fully cached
// in a reverse proxy (i.e. Fastly). Fastly cache entries Vary by member tier, but for anything completely specific
// to an individuals session or member account, this Javascript is here to shim those features in.

const source = $('meta[name=authenticity-token-source]');
const token = $('meta[name=csrf-token]');
const flash = $('#flash-shiv');
const member = $('[data-current-member]');
const hi_member_link = $('#member_greeting');
const body = $('body');
const loggedOut = !!$('body.logged-out').length;
const reloadedAlready = (window.location.href.substr(-2) === "?r");

const src = source.attr('content');

if (src) {
  $.ajax({url: src})
    .done(function(data) {      
      // Ensure global authenticity token is set.
      token.attr('content', data.authenticity_token);

      if (!reloadedAlready) {
        // Reload the page if we're seeing the logged out body class while ping is
        // claiming we're logged in.
        if (data.id && loggedOut) {
          console.debug("redirection being triggered - should be logged in");
          console.debug(data);
          window.location = window.location.href + "?r";
        }

        if (!data.id && !loggedOut) {
          console.debug("redirection being triggered - should be logged out");
          console.debug(data);
          window.location = window.location.href + "?r";
        }
      }
      else {
        console.debug("have been redirected");
        console.debug(data);
        window.history.replaceState({}, document.title, location.pathname);
      }
 
      // Insert flash message html, if any.
      flash.replaceWith(data.flash);

      // Set any data attributes that use member id, and place in the body and window
      member.attr('data-current-member', data.id);
      window.currentMemberID = data.id;
      body.data('current-member', data.id);


      // Set the member's name in the topbar
      hi_member_link.text('Hi ' + data.name);

      // Ensure authenticity token is always sent in ajax requests.
      $.ajaxSetup({
        beforeSend: function(xhr, settings) {
          if (!settings.crossDomain) {
            xhr.setRequestHeader('X-CSRF-Token', data.authenticity_token);
          }
        }
      });

      // Ensure authenticity token is always set in forms.
      $('form input[name=authenticity_token]').attr('value', data.authenticity_token);

      var ga_s = document.createElement("script");
      ga_s.type = 'text/javascript';
      ga_s.innerHTML = data.google_analytics_events;
      $('head').append(ga_s);

      // Add marketo dom elements
      $('body').append(data.marketo_analytics_elements);
  });
}

